import getConfig from 'next/config';

/**
 * @typedef Config
 * @property {string} environment Application environment
 */

/** @type {Config} */
export const config = getConfig().publicRuntimeConfig;
